<template>
  <v-container fluid class="material-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Material</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">New Material</p>
                        <v-text-field
                          class="mb-4"
                          v-model="add_material.materialnum"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Material Num"
                          persistent-hint
                          single-line hint="Enter the material num">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_material.materialname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Material Name"
                          persistent-hint
                          single-line hint="Enter the material name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="add_material.materialinfo"
                          outlined
                          dense
                          placeholder="Info"
                          persistent-hint
                          single-line hint="Enter the material info">
                        </v-text-field>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="['Material', 'Overhead', 'Other Material']"
                          v-model="add_material.materialtype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the material type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="brands.map(x => {
                            return {text: x.brandname, value: x._id};
                          })"
                          v-model="add_material.brandid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Brand"
                          persistent-hint
                          single-line hint="Please choose the material brand">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6" sm="5">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/material/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onChangeImage" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertMaterial()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      add_material: {},
      error: undefined,
      errorindex: undefined,
      haserror: false,
    }
  },

  methods: {
    ...mapActions('Material', ['insertMaterialRequest', 'insertMaterialWithImageRequest', 'getMaterialsRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    checkError(){
      if(!this.add_material.materialnum){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.add_material.materialname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.add_material.materialtype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.add_material.brandid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertMaterial() {
      if(this.add_material.imagefile) this.insertMaterialWithImageRequest(this.add_material);
      else this.insertMaterialRequest(this.add_material);
    
      router.push('/material/list')
    },
    onChangeImage(file) {
      if (!file) {return;}
      this.add_material.imagefile = file;
      this.add_material.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    }
  },
  computed: {
    ...mapState('Material', ['isReceiving']),
    ...mapState('Brand', ['brands']),
  },
  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.materialcategories.length==0) await this.getMaterialCategoriesRequest();
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
